/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_You_SubtitleInputs */

const en_ui_onboarding_you_subtitle = /** @type {(inputs: Ui_Onboarding_You_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender, resting and max HR feed the heart-rate-based training load. Weight and birth year are optional — you can add them later in Settings.`)
};

const de_ui_onboarding_you_subtitle = /** @type {(inputs: Ui_Onboarding_You_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht, Ruhe- und Max-HF fließen in die herzfrequenzbasierte Trainingsbelastung ein. Gewicht und Geburtsjahr sind optional – du kannst sie später in den Einstellungen ergänzen.`)
};

/**
* | output |
* | --- |
* | "Gender, resting and max HR feed the heart-rate-based training load. Weight and birth year are optional — you can add them later in Settings." |
*
* @param {Ui_Onboarding_You_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_you_subtitle = /** @type {((inputs?: Ui_Onboarding_You_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_You_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_you_subtitle(inputs)
	return de_ui_onboarding_you_subtitle(inputs)
});